unit View.Cfop_Configuracoes.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewCfop_ConfiguracoesList = class(TForm)
    btNew: TButton;
    Cfop_ConfiguracoesDataset: TXDataWebDataSet;
    Cfop_ConfiguracoesDatasetid: TIntegerField;
    Cfop_ConfiguracoesDatasetaliado_id: TIntegerField;
    Cfop_ConfiguracoesDatasetdata_base_id: TIntegerField;
    Cfop_ConfiguracoesDatasetcfop: TStringField;
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_substituicao: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_servico: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_participa_dre: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_devolucao: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_transporte: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_combustivel: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_transferencia: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_preco_custo: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_perda: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins: TBooleanField;
    Cfop_ConfiguracoesDatasetcodigo_interno: TIntegerField;
    Cfop_ConfiguracoesDatasetexcluido: TBooleanField;
    Cfop_ConfiguracoesDatasetinclusao: TDateTimeField;
    Cfop_ConfiguracoesDatasetalteracao: TDateTimeField;
    Cfop_ConfiguracoesDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCfop_ConfiguracoesList: TFViewCfop_ConfiguracoesList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCfop_ConfiguracoesList }

procedure TFViewCfop_ConfiguracoesList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCfop_ConfiguracoesList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCfop_ConfiguracoesList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCfop_ConfiguracoesList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCfop_ConfiguracoesList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCfop_ConfiguracoesList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCfop_ConfiguracoesList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Cfop_ConfiguracoesDataset.Connection.Model.DefaultSchema.FindEntityType(Cfop_ConfiguracoesDataset.EntitySetName),
      Cfop_ConfiguracoesDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCfop_ConfiguracoesList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('cfop_configuracoes', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Cfop_ConfiguracoesDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCfop_ConfiguracoesList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.cfop_configuracoes.list.pagination.info');
  btNew := TButton.Create('view.cfop_configuracoes.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.cfop_configuracoes.list.table');
  cbPageSize := TComboBox.Create('view.cfop_configuracoes.list.cbPageSize');
  edSearch := TEdit.Create('view.cfop_configuracoes.list.search');
  lcPaginator := TListControl.Create('view.cfop_configuracoes.list.pagination');
  Cfop_ConfiguracoesDataset := TXDataWebDataSet.Create(Self);
  Cfop_ConfiguracoesDatasetid := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetaliado_id := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetdata_base_id := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop := TStringField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_movimenta_estoque := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_gera_financeiro := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_substituicao := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_simples_faturamento := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_servico := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_participa_dre := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_devolucao := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_transporte := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_combustivel := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_transferencia := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_preco_custo := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_perda := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcodigo_interno := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetexcluido := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetinclusao := TDateTimeField.Create(Self);
  Cfop_ConfiguracoesDatasetalteracao := TDateTimeField.Create(Self);
  Cfop_ConfiguracoesDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDataset.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetid.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetaliado_id.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetdata_base_id.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_gera_financeiro.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_substituicao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_simples_faturamento.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_servico.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_participa_dre.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_devolucao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_transporte.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_combustivel.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_transferencia.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_preco_custo.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_perda.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcodigo_interno.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetexcluido.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetinclusao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetalteracao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewCfop_ConfiguracoesList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop';
      Title := 'cfop';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_movimenta_estoque';
      Title := 'cfop_movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_gera_financeiro';
      Title := 'cfop_gera_financeiro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_substituicao';
      Title := 'cfop_substituicao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_simples_faturamento';
      Title := 'cfop_simples_faturamento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_servico';
      Title := 'cfop_servico';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_participa_dre';
      Title := 'cfop_participa_dre';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_devolucao';
      Title := 'cfop_devolucao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_transporte';
      Title := 'cfop_transporte';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_combustivel';
      Title := 'cfop_combustivel';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_transferencia';
      Title := 'cfop_transferencia';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_preco_custo';
      Title := 'cfop_preco_custo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_perda';
      Title := 'cfop_perda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_conciliacao_cupons';
      Title := 'cfop_conciliacao_cupons';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_tributa_pis_cofins';
      Title := 'cfop_tributa_pis_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Cfop_ConfiguracoesDataset.SetParentComponent(Self);
    Cfop_ConfiguracoesDataset.Name := 'Cfop_ConfiguracoesDataset';
    Cfop_ConfiguracoesDataset.EntitySetName := 'Cfop_Configuracoes';
    Cfop_ConfiguracoesDataset.Connection := DMConnection.ApiConnection;
    Cfop_ConfiguracoesDataset.Left := 72;
    Cfop_ConfiguracoesDataset.Top := 144;
    Cfop_ConfiguracoesDatasetid.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetid.Name := 'Cfop_ConfiguracoesDatasetid';
    Cfop_ConfiguracoesDatasetid.FieldName := 'id';
    Cfop_ConfiguracoesDatasetid.Required := True;
    Cfop_ConfiguracoesDatasetaliado_id.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetaliado_id.Name := 'Cfop_ConfiguracoesDatasetaliado_id';
    Cfop_ConfiguracoesDatasetaliado_id.FieldName := 'aliado_id';
    Cfop_ConfiguracoesDatasetaliado_id.Required := True;
    Cfop_ConfiguracoesDatasetdata_base_id.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetdata_base_id.Name := 'Cfop_ConfiguracoesDatasetdata_base_id';
    Cfop_ConfiguracoesDatasetdata_base_id.FieldName := 'data_base_id';
    Cfop_ConfiguracoesDatasetdata_base_id.Required := True;
    Cfop_ConfiguracoesDatasetcfop.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop.Name := 'Cfop_ConfiguracoesDatasetcfop';
    Cfop_ConfiguracoesDatasetcfop.FieldName := 'cfop';
    Cfop_ConfiguracoesDatasetcfop.Required := True;
    Cfop_ConfiguracoesDatasetcfop.Size := 255;
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.Name := 'Cfop_ConfiguracoesDatasetcfop_movimenta_estoque';
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.FieldName := 'cfop_movimenta_estoque';
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.Required := True;
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.Name := 'Cfop_ConfiguracoesDatasetcfop_gera_financeiro';
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.FieldName := 'cfop_gera_financeiro';
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.Required := True;
    Cfop_ConfiguracoesDatasetcfop_substituicao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_substituicao.Name := 'Cfop_ConfiguracoesDatasetcfop_substituicao';
    Cfop_ConfiguracoesDatasetcfop_substituicao.FieldName := 'cfop_substituicao';
    Cfop_ConfiguracoesDatasetcfop_substituicao.Required := True;
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.Name := 'Cfop_ConfiguracoesDatasetcfop_simples_faturamento';
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.FieldName := 'cfop_simples_faturamento';
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.Required := True;
    Cfop_ConfiguracoesDatasetcfop_servico.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_servico.Name := 'Cfop_ConfiguracoesDatasetcfop_servico';
    Cfop_ConfiguracoesDatasetcfop_servico.FieldName := 'cfop_servico';
    Cfop_ConfiguracoesDatasetcfop_servico.Required := True;
    Cfop_ConfiguracoesDatasetcfop_participa_dre.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_participa_dre.Name := 'Cfop_ConfiguracoesDatasetcfop_participa_dre';
    Cfop_ConfiguracoesDatasetcfop_participa_dre.FieldName := 'cfop_participa_dre';
    Cfop_ConfiguracoesDatasetcfop_participa_dre.Required := True;
    Cfop_ConfiguracoesDatasetcfop_devolucao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_devolucao.Name := 'Cfop_ConfiguracoesDatasetcfop_devolucao';
    Cfop_ConfiguracoesDatasetcfop_devolucao.FieldName := 'cfop_devolucao';
    Cfop_ConfiguracoesDatasetcfop_devolucao.Required := True;
    Cfop_ConfiguracoesDatasetcfop_transporte.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_transporte.Name := 'Cfop_ConfiguracoesDatasetcfop_transporte';
    Cfop_ConfiguracoesDatasetcfop_transporte.FieldName := 'cfop_transporte';
    Cfop_ConfiguracoesDatasetcfop_transporte.Required := True;
    Cfop_ConfiguracoesDatasetcfop_combustivel.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_combustivel.Name := 'Cfop_ConfiguracoesDatasetcfop_combustivel';
    Cfop_ConfiguracoesDatasetcfop_combustivel.FieldName := 'cfop_combustivel';
    Cfop_ConfiguracoesDatasetcfop_combustivel.Required := True;
    Cfop_ConfiguracoesDatasetcfop_transferencia.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_transferencia.Name := 'Cfop_ConfiguracoesDatasetcfop_transferencia';
    Cfop_ConfiguracoesDatasetcfop_transferencia.FieldName := 'cfop_transferencia';
    Cfop_ConfiguracoesDatasetcfop_transferencia.Required := True;
    Cfop_ConfiguracoesDatasetcfop_preco_custo.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_preco_custo.Name := 'Cfop_ConfiguracoesDatasetcfop_preco_custo';
    Cfop_ConfiguracoesDatasetcfop_preco_custo.FieldName := 'cfop_preco_custo';
    Cfop_ConfiguracoesDatasetcfop_preco_custo.Required := True;
    Cfop_ConfiguracoesDatasetcfop_perda.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_perda.Name := 'Cfop_ConfiguracoesDatasetcfop_perda';
    Cfop_ConfiguracoesDatasetcfop_perda.FieldName := 'cfop_perda';
    Cfop_ConfiguracoesDatasetcfop_perda.Required := True;
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.Name := 'Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons';
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.FieldName := 'cfop_conciliacao_cupons';
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.Required := True;
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.Name := 'Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins';
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.FieldName := 'cfop_tributa_pis_cofins';
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.Required := True;
    Cfop_ConfiguracoesDatasetcodigo_interno.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcodigo_interno.Name := 'Cfop_ConfiguracoesDatasetcodigo_interno';
    Cfop_ConfiguracoesDatasetcodigo_interno.FieldName := 'codigo_interno';
    Cfop_ConfiguracoesDatasetcodigo_interno.Required := True;
    Cfop_ConfiguracoesDatasetexcluido.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetexcluido.Name := 'Cfop_ConfiguracoesDatasetexcluido';
    Cfop_ConfiguracoesDatasetexcluido.FieldName := 'excluido';
    Cfop_ConfiguracoesDatasetinclusao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetinclusao.Name := 'Cfop_ConfiguracoesDatasetinclusao';
    Cfop_ConfiguracoesDatasetinclusao.FieldName := 'inclusao';
    Cfop_ConfiguracoesDatasetalteracao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetalteracao.Name := 'Cfop_ConfiguracoesDatasetalteracao';
    Cfop_ConfiguracoesDatasetalteracao.FieldName := 'alteracao';
    Cfop_ConfiguracoesDatasetexclusao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetexclusao.Name := 'Cfop_ConfiguracoesDatasetexclusao';
    Cfop_ConfiguracoesDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Cfop_ConfiguracoesDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Cfop_ConfiguracoesDataset.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetid.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetaliado_id.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetdata_base_id.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_substituicao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_servico.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_participa_dre.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_devolucao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_transporte.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_combustivel.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_transferencia.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_preco_custo.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_perda.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcodigo_interno.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetexcluido.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetinclusao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetalteracao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
